import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import Icon from "./Icon";
import { ProtectedElement } from "./Protected";

// const AccountName = styled.li`
//   position: absolute;
//   top: calc(100% + 1rem);
//   left: 0;
// `;

const SidebarList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: inline-block;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
    margin-right: 2rem;
  }

  a {
    align-items: center;
    display: flex;
    color: inherit;
    font-weight: bold;
    font-size: 0.7em;
    text-transform: uppercase;

    svg {
      fill: inherit;
    }
  }

  a.active {
    color: #e52225;
    fill: #e52225;
  }
`;

const UserBarStrip = styled.aside`
  background: #fff;
  box-shadow: none;
  color: #1f1f1f;
  height: auto;
  position: relative;
  width: 100%;

  svg {
    fill: #1f1f1f;
    height: 1.5rem;
    width: 1.5rem;
    float: left;
    margin-right: 0.5rem;
  }
`;

// eslint-disable-next-line
const LinkWithPartiallyCurrent = ({ sub, ...props }) => (
  <Link
    {...props}
    getProps={({ isPartiallyCurrent, isCurrent, location: { pathname } }) =>
      (sub ? String(pathname).includes(sub) : isPartiallyCurrent) || isCurrent
        ? {
            className: "active",
          }
        : {}
    }
  />
);

// eslint-disable-next-line
const Sidebar = ({ name, role }) => (
  <UserBarStrip>
    <SidebarList>
      {/* <AccountName>
        <small>
          {name} ({role})
        </small>
      </AccountName> */}
      <li>
        <LinkWithPartiallyCurrent to="/flextime" sub="timesheet">
          <Icon name="Invoice" />
          Timesheets
        </LinkWithPartiallyCurrent>
      </li>
      <ProtectedElement rule="moderator">
        <li>
          <LinkWithPartiallyCurrent to="/flextime/company">
            <Icon name="JobPostings" />
            Companies
          </LinkWithPartiallyCurrent>
        </li>
        <li>
          <LinkWithPartiallyCurrent to="/flextime/user">
            <Icon name="User" />
            Users
          </LinkWithPartiallyCurrent>
        </li>
      </ProtectedElement>
      <ProtectedElement rule="admin">
        <li>
          <LinkWithPartiallyCurrent to="/flextime/payout">
            <Icon name="Payout" />
            Placements
          </LinkWithPartiallyCurrent>
        </li>
      </ProtectedElement>
      <ProtectedElement rule="recruitment">
        <li>
          <LinkWithPartiallyCurrent to="/flextime/contract">
            <Icon name="NewContract" />
            Contracts
          </LinkWithPartiallyCurrent>
        </li>
      </ProtectedElement>
      <ProtectedElement rule="moderator">
        <li>
          <LinkWithPartiallyCurrent to="/flextime/tools">
            <Icon name="Bolt" />
            Tools
          </LinkWithPartiallyCurrent>
        </li>
      </ProtectedElement>
      <li>
        <LinkWithPartiallyCurrent to="/flextime/change-password">
          <Icon name="Interview" />
          Password
        </LinkWithPartiallyCurrent>
      </li>
    </SidebarList>
  </UserBarStrip>
);

export default Sidebar;
